import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const KEY = "xc_from_coach";
export const markFromCoach = (tool) => sessionStorage.setItem(KEY, JSON.stringify({ tool, at: Date.now() }));

// After the Coach sends him into an experience, a gentle way back to her.
export default function BackToCoach() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [ctx, setCtx] = useState(null);
  useEffect(() => {
    try {
      const c = JSON.parse(sessionStorage.getItem(KEY) || "null");
      setCtx(c && Date.now() - c.at < 3 * 3600 * 1000 && pathname !== "/talk" ? c : null);
    } catch { setCtx(null); }
  }, [pathname]);
  if (!ctx) return null;
  const back = () => { sessionStorage.removeItem(KEY); navigate(`/talk?back=${encodeURIComponent(ctx.tool || "")}`); };
  return (
    <button onClick={back} data-testid="back-to-coach"
      className="fixed z-40 bottom-24 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 rounded-full border border-primary/40 bg-[#0d1426]/90 backdrop-blur-xl px-5 py-2.5 text-sm text-foreground shadow-[0_8px_30px_rgba(0,0,0,0.4)] hover:bg-[#121b33] transition-colors">
      <MessageCircle className="w-4 h-4 text-primary" /> Back to your Coach
    </button>
  );
}
